import React, { useEffect } from 'react';
import './automation.css';
import Header from "../../components/Header/Header";
import TextareaAutosize from "react-textarea-autosize";
import { automationAction } from "../../redux/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import {
    getAutomationSagaAction,
    removeBirthdayAutomationSagaAction,
    updateBirthdayAutomationSagaAction
} from "../../redux/sagaActions";

const Automation = () => {
    const dispatch = useDispatch();

    const automation = useSelector(state => state.automation);
    const establishmentList = useSelector(state => state.establishmentList);

    useEffect(() => {
        // Запрашиваем список автоматизаций
        dispatch(getAutomationSagaAction());
    }, []);

    return (
        <>
            <Header/>
            <div className="page">
                <div className="auto">
                    <div className="auto__item">
                        {
                            automation.happy_birthday.id &&
                            <div className="auto__remove" onClick={ () => {
                                if (!window.confirm('Вы действительно хотите удалить автоматизацию?')) return;
                                dispatch(removeBirthdayAutomationSagaAction({ id: automation.happy_birthday.id }));
                            } }>Удалить автоматизацию</div>
                        }
                        <div className="auto__title">Поздравление с днём рождения</div>
                        <div className="auto__field">
                            <div className="auto__caption">Заголовок</div>
                            <input type="text" className="input"
                                value={ automation.happy_birthday.title }
                                onInput={ event => dispatch(automationAction({ ...automation, happy_birthday: { ...automation.happy_birthday, title: event.target.value } })) }
                            />
                        </div>
                        <div className="auto__field">
                            <div className="auto__caption">Текст поздравления</div>
                            <TextareaAutosize type="text" className="input input--textarea"
                                              value={ automation.happy_birthday.message }
                                              onInput={ event => dispatch(automationAction({ ...automation, happy_birthday: { ...automation.happy_birthday, message: event.target.value } })) }
                            />
                        </div>
                        <div className="auto__field">
                            <div className="input__caption input__caption--required" style={{ marginBottom: '10px' }}>Для каких заведений</div>
                            {
                                establishmentList.map(elem => {
                                    return (
                                        <div style={{ marginBottom: '10px' }} key={ elem.id }>
                                            <div className="checkbox__wrapper" onClick={ () => {
                                                // Старый массив с заведениями
                                                let est = [...automation.happy_birthday.establishments];
                                                // Ищем индекс выбранного элемента
                                                let findIndex = est.findIndex(el => el === elem.id);
                                                // Если в массиве есть выбранный элемент, удаляем его
                                                if (findIndex + 1) {
                                                    est.splice(findIndex, 1);
                                                }
                                                else {
                                                    est.push(elem.id);
                                                }

                                                dispatch(automationAction({
                                                    ...automation,
                                                    happy_birthday: {
                                                        ...automation.happy_birthday,
                                                        establishments: est
                                                    }
                                                }));
                                            } }>
                                                <div className={ `checkbox ${ automation.happy_birthday.establishments.includes(elem.id) ? 'checkbox--active' : '' }` }/>
                                                <div className="checkbox__caption">{ elem.name }</div>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                        <div className="auto__field">
                            <div className="auto__submit"
                                 onClick={ () => dispatch(updateBirthdayAutomationSagaAction({
                                     id: automation.happy_birthday.id,
                                     title: automation.happy_birthday.title,
                                     message: automation.happy_birthday.message,
                                     establishments: JSON.stringify(automation.happy_birthday.establishments),
                                 })) }
                            >Сохранить</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Automation;